var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H11C11.5304 1 12.0391 1.21071 12.4142 1.58579C12.7893 1.96086 13 2.46957 13 3V9.66667C13 10.1971 12.7893 10.7058 12.4142 11.0809C12.0391 11.456 11.5304 11.6667 11 11.6667H3C2.46957 11.6667 1.96086 11.456 1.58579 11.0809C1.21071 10.7058 1 10.1971 1 9.66667V3Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00033 3.66797H10.3337M9.00033 6.33464H10.3337M3.66699 9.0013H10.3337M3.66699 5.0013C3.66699 5.35492 3.80747 5.69406 4.05752 5.94411C4.30756 6.19416 4.6467 6.33464 5.00033 6.33464C5.35395 6.33464 5.69309 6.19416 5.94313 5.94411C6.19318 5.69406 6.33366 5.35492 6.33366 5.0013C6.33366 4.64768 6.19318 4.30854 5.94313 4.05849C5.69309 3.80844 5.35395 3.66797 5.00033 3.66797C4.6467 3.66797 4.30756 3.80844 4.05752 4.05849C3.80747 4.30854 3.66699 4.64768 3.66699 5.0013Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/job_title.14d46355abcd3427a2ff830e658dbf04.svg";
export { ForwardRef as ReactComponent };